export class ClientAreaDetails {
    ClientCode: number;
    ClientDal: Date;
    ClientCategory:string
    ClientTopology:string;
    AssociatedList:string;
    LastOrderNumber:string;
    LastOrderDate:Date;
    OrdersQueued:number;
    OrdersProcessing:number;
    CurrentOrders:number;
    OrdersCancelled:number;
    LastQuoteNumber: string;
    LastQuoteDate:Date;
    QuotesOnHold:number;
    ConfirmedQuotes:number
    EstimatedSentOrders:number;
    NewNoteOrdersCount:number;
    OrderNoteList: ClientAreaOrderNote[];
    FormattedDateOrder: string;
    FormattedDateQuote: string;
}

export class ClientAreaOrderNote {
    OrderId:number;
    UserCreated:string;
    DateCreated:string;
    OrderName:string;
    NoteDescription:string;
}

export class ClientAreaUserProfile {
    CompanyName: string;
    Piva:string;
    TaxCode: string;
    ContactFirstName: string;
    ContactLastName: string;
    Address: string;
    City: string;
    AreaCode: string;
    ZipCode: string;
    ContactPhone: string;
    ContactMobile: string;
    UserGroup: number;
    DefaultAddressId: number;
    Password: string;
    Addresses: ClientAreaUserAddress[];
    ClientCategory: string;
}

export class ClientAreaUserAddress {
    AddressId: number;
    Recipient: string;
    Address: string;
    City: string;
    Province: string;
    ZipCode: string;
    Phone: string;
    Mobile: string;
    DefaultAddress: number;
}
export class ClientAreaOrderDetails {
    OrderId: number;
    OrderNumber: string;
    Status: number;
    Price: number;
    StringPrice: string;
    Payment: number;
    Shipment: number;
    FileVerification: boolean;
    Jobname: string;
    OrderDate: Date;
    ShippingDeliveryDate: Date;
    UserCreated: string;
    ReferenceAndQuote: number;
    TotalProcesses: number;
    Voucher: string;
    Processes: number;
    AdditionalMode: number;
    ShipmentCost: number;
    TaxCost: number;
    Vat: number;
    TotalCost: number;
    Name: string;
    Piva: string;
    TaxCode: string;
    Address: string;
    ZipCode: string;
    City: string;
    ContactPhone: string;
    Email: string;
    ShipingType: string;
    Recipient: string;
    ShippingAddress: string;
    ShipingZipCode: string;
    ShipingProvince: string;
    ShipingCity: string;
    ShipingTelephone: string;
    ShipingMobile: string;
    PaymentType: string;
    PaymentDescription: string;
    TotalWeight: number;
    CompanyName: string;
    OrderNoteList: ClientAreaOrderNote[];
    ProcessingOrderList: ClientAreaProcessingOrders[];
    OrderProcessMessageList: ClientAreaOrderProcessMessages[];
    PdfUrl: string;
    Currency: any;
    CurrencyCode: string;
    GatewayAccount: string;
    PaymentDoneUrl: string;
    TrackingUrl: string;
    GatewayUrl: string;
    PaymentStatus: number;
    StrTotalBeforeTax: string;
    BonificoCro: string;
    BonificoTrn: string;
    IsNewPaypalIntegration: boolean;
    UsePaypalProduction: boolean;
    PaypalButtonStyle: PaypalButtonStyleModel
}

export class PaypalButtonStyleModel {
    PaypalButtonColor: string;
    PaypalButtonHeight: string;
    PaypalButtonLabel: string;
    PaypalButtonShape: string;
    PaypalButtonSize: string;
    PaypalButtonTagline: boolean;
}

export class ClientAreaProcessingOrders {
    Id:number;
    Jobname:string;
    RefererName:string;
    Status: number;
    FileVerification:boolean;
    Details:string;
    FileUploadUrl:string;
    FileUploadSecuredUrl:any;
    PreflightUploadUrl:any;
    PreflightUploadSecuredUrl:any;
    FileProvider: string;
    Files: ClientAreaOrderProcessFile[];
}
export class ClientAreaOrderProcessMessages {
    CreatedBy:string;
    Subject:string;
    Description: string;
    From:number;
    StringDateCreated:string;
}

export class  ClientAreaOrderProcessFile {
    FileName:string;
    Size :string;
    UploadDate:Date;
    }


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/models/settings/client-area.ts